import ApplicationController from "application_controller.js";

export default class extends ApplicationController  {
  debug = false;

  static values = {
    delay: { type: Number, default: 0 },
  };

  connect() {
    this.log_function("connect");

    this.timeout = setTimeout(() => {
      this.element.scrollIntoView({
        behavior: "smooth",
        block: "center",
        center: "center",
      });
    }, this.delayValue);
  }

  disconnect(){
    this.log_function("disconnect");

    clearTimeout(this.timeout);
  }
}
